/* NJ EMI Offers (added 23 Oct 2026) */
(() => {
  // product-blocks renders twice (main + sticky form), so this file can be included twice
  if (window.njEmiOffers) return;
  window.njEmiOffers = true;
  const d = document;
  const cfgEl = d.getElementById('emi-offers-config');
  const first = d.querySelector('[data-emi-open]');
  if (!cfgEl || !first) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const nf = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });
  const fmt = (n) => '₹' + nf.format(Math.round(n));
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  // Same Snapmint formula as product-blocks.liquid calcEMI(): price x 1.05 / 12
  const snap = (p) => Math.round(p * 1.05 / 12);
  const NAMES = { sm: 'Snapmint', bj: 'Bajaj Finserv EMI Card', cc: 'Credit Card on UPI' };
  const keys = Object.keys(NAMES).filter((k) => cfg[k] && cfg[k].on);

  let price = +first.dataset.price / 100;
  let dlg, trigger, sel = 0;

  // "3:0, 6:14, 9:" -> [{m:3,r:0},{m:6,r:14},{m:9,r:null}]; null rate = calculated at checkout
  const tenures = (s) => (s || '').split(',').map((x) => x.split(':')).filter((a) => +a[0] > 0)
    .map((a) => ({ m: +a[0], r: a[1] == null || a[1].trim() === '' ? null : +a[1] }));
  // Standard reducing-balance EMI on the annual rate the merchant entered
  const emi = (p, m, r) => { if (!r) return p / m; const i = r / 1200, f = Math.pow(1 + i, m); return p * i * f / (f - 1); };
  const offReason = (c) => (c.min && price < c.min ? 'Available on orders of ' + fmt(c.min) + ' and above'
    : c.max && price > c.max ? 'Available on orders up to ' + fmt(c.max) : '');

  const rows = (k) => {
    if (k === 'sm') { const e = snap(price); return [{ m: 12, e, l: 'Incl. charges', t: e * 12 }]; }
    return tenures(cfg[k].t).map((t) => {
      if (t.r == null || isNaN(t.r)) return { m: t.m };
      const e = Math.round(emi(price, t.m, t.r));
      return { m: t.m, e, l: t.r ? t.r + '% p.a.' : 'No-cost', t: t.r ? e * t.m : price };
    });
  };
  const hasNoCost = () => keys.some((k) => k !== 'sm' && !offReason(cfg[k]) && tenures(cfg[k].t).some((t) => t.r === 0));

  function panel(k) {
    const c = cfg[k], off = offReason(c);
    if (off) return '<p class="emi-off">' + off + '</p>';
    const r = rows(k);
    let h = r.length ? '<table class="emi-tbl"><thead><tr><th>Tenure</th><th>Monthly EMI</th><th>Interest</th><th>Total</th></tr></thead><tbody>' +
      r.map((x) => '<tr><td>' + x.m + ' months</td>' + (x.e == null ? '<td colspan="3">Calculated at checkout</td>'
        : '<td><b>' + fmt(x.e) + '</b></td><td' + (x.l === 'No-cost' ? ' class="emi-nc"' : '') + '>' + x.l + '</td><td>' + fmt(x.t) + '</td>') + '</tr>').join('') +
      '</tbody></table>' : '<p class="emi-note">Tenures and rates are shown at checkout.</p>';
    if (c.note) h += '<p class="emi-note">' + esc(c.note) + '</p>';
    return h;
  }

  function render() {
    if (!dlg) return;
    dlg.querySelector('.emi-tabs').innerHTML = keys.map((k, i) => '<button type="button" role="tab" class="emi-tab' + (offReason(cfg[k]) ? ' is-off' : '') +
      '" data-emi-tab="' + i + '" id="emi-tab-' + k + '" aria-controls="emi-panel" aria-selected="' + (i === sel) + '"' + (i === sel ? '' : ' tabindex="-1"') + '>' + NAMES[k] + '</button>').join('');
    const p = dlg.querySelector('#emi-panel');
    p.setAttribute('aria-labelledby', 'emi-tab-' + keys[sel]);
    p.innerHTML = keys.length ? panel(keys[sel]) : '';
  }

  function build() {
    dlg = d.createElement('dialog');
    dlg.className = 'emi-dlg';
    dlg.setAttribute('aria-labelledby', 'emi-dlg-title');
    dlg.innerHTML = '<div class="emi-dlg__in"><div class="emi-dlg__head"><h2 id="emi-dlg-title">EMI offers</h2>' +
      '<button type="button" class="emi-x" data-emi-close aria-label="Close"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2"/></svg></button></div>' +
      '<div class="emi-tabs" role="tablist"></div><div id="emi-panel" role="tabpanel"></div><p class="emi-disc">' + esc(cfg.disc) + '</p></div>';
    // Fires for Esc (native cancel), X and backdrop clicks
    dlg.addEventListener('close', () => {
      dlg.classList.remove('is-in');
      d.documentElement.classList.remove('emi-lock');
      if (trigger) trigger.focus();
    });
    d.body.appendChild(dlg);
  }

  function open(btn) {
    trigger = btn;
    if (!dlg) build();
    const firstOn = keys.findIndex((k) => !offReason(cfg[k]));
    sel = firstOn < 0 ? 0 : firstOn;
    render();
    d.documentElement.classList.add('emi-lock');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    requestAnimationFrame(() => dlg.classList.add('is-in'));
  }
  const close = () => (dlg.close ? dlg.close() : (dlg.removeAttribute('open'), dlg.dispatchEvent(new Event('close'))));

  function update() {
    d.querySelectorAll('[data-emi-open]').forEach((s) => {
      s.dataset.price = Math.round(price * 100);
      const f = s.querySelector('[data-emi-from]'), n = s.querySelector('[data-emi-nc]');
      if (f) f.textContent = fmt(snap(price));
      if (n) n.hidden = !hasNoCost();
    });
    if (dlg && dlg.open) render();
  }
  const setPrice = (paise) => { paise = +paise; if (paise > 0 && paise / 100 !== price) { price = paise / 100; update(); } };

  let variants = [];
  try { variants = JSON.parse(d.getElementById('emi-product-data').textContent).variants || []; } catch (e) {}
  const byId = (id) => { const v = variants.find((x) => x.id === +id); if (v) setPrice(v.price); };

  d.addEventListener('click', (e) => {
    const t = e.target, btn = t.closest('[data-emi-open]');
    if (btn) return open(btn);
    if (!dlg || !dlg.open) return;
    if (t === dlg || t.closest('[data-emi-close]')) return close();
    const tab = t.closest('[data-emi-tab]');
    if (tab) { sel = +tab.dataset.emiTab; render(); dlg.querySelector('[aria-selected=true]').focus(); }
  });

  // Variant changes: theme custom events, form change, then MutationObservers as fallback
  ['variant:changed', 'variantChange', 'variant-change'].forEach((n) => d.addEventListener(n, (e) => {
    const v = e.detail && (e.detail.variant || e.detail);
    if (v && v.price) setPrice(v.price);
  }));
  d.addEventListener('change', (e) => {
    const f = e.target.closest('form[action*="/cart/add"]');
    if (f) setTimeout(() => { const i = f.querySelector('[name="id"]'); if (i) byId(i.value); });
  });
  const idInput = d.querySelector('form[action*="/cart/add"] [name="id"]');
  if (idInput) new MutationObserver(() => byId(idInput.value)).observe(idInput, { attributes: true, attributeFilter: ['value'] });
  const priceEl = d.querySelector('.product-price[data-price]');
  if (priceEl) new MutationObserver(() => setPrice(priceEl.getAttribute('data-price'))).observe(priceEl, { attributes: true, attributeFilter: ['data-price'] });

  update();
})();
